// 统一请求路径前缀在libs/axios.js中修改
import {postJsonRequest,getRequest, postFormRequest, postRequest, putRequest, deleteRequest, importRequest, postFZRequest } from '@/libs/axios';

// 购物车列表
export const getCarList = (params) => {
    return postRequest('/videoclip/copyright/car/list', params)
}

// 添加到购物车
export const getCarAdd = (params) => {
    return postRequest('/videoclip/copyright/car/add', params)
}

// 从购物车中删除
export const getCarDelete = (params) => {
    return postRequest('/videoclip/copyright/car/delete', params)
}
// 获取类型
export const getCooperationDurationType = (params) =>{
    return getRequest('/dictData/getByType/cooperation_duration_type',params)
}
// 获取媒体

export const getMediaPlatform = (params) =>{
    return getRequest('/dictData/getByType/media_platform',params)
}


//自媒体账号管理 立即同步
export const immediateSynchronization = (params) => {
    return postRequest('/videoclip/wemedia/wemediaAccount/synchronizeDataRequest', params)
}

// 导入收益Excel excelUniqImport  ----分发导入
export const excelFfImport = (params) => {
    return postFormRequest('/incomeAnalyse/importIncomeAnalyse',params)
}

//自媒体管理 全部
export const getAllwemediaManageList = (params) => {
    return getRequest('/videoclip/wemedia/getAll', params)
}

//自媒体管理 查看详情
export const wemediaManageDetail = (id,params) => {
    return getRequest(`/videoclip/wemedia/get/${id}`, params)
}

//自媒体账号管理 列表
export const wemediaAccountManageList = (params) => {
    return getRequest('/videoclip/wemedia/wemediaAccount/getByPage', params)
}

//自媒体账号管理 编辑
export const wemediaAccountManageEdit = (params) => {
    return postFormRequest('/videoclip/wemedia/wemediaAccount/insertOrUpdate', params)
}

// 自媒体账号管理  删除
export const wemediaAccountManageDelect = (ids, params) => {
    return deleteRequest(`/videoclip/wemedia/wemediaAccount/delFrontByIds/${ids}`, params)
}

// 导入收益Excel excelUniqImport
export const excelUniqImport = (params) => {
    return postFormRequest('/videoclip/wemedia/wemediaStatistics/importWemediaIncome',params)
}

// 个人中心-自媒体-我的作品
export const getWorkPage = (params) => {
    return postFZRequest('/videoclip/wemedia/work/page', params)
}

// 个人中心-自媒体-我的作品-作品导出
export const getWorkExport = (params) => {
    return getRequest('/videoclip/wemedia/work/export', params)
}

// 获取版权类型接口
export const getCopyrightTypeList = (params) =>{
    return getRequest('/dictData/getByType/copyright_category',params)
}

// 获取运营渠道列表
export const getOrderChannels = (params) => {
    return postFZRequest('/videoclip/copyright/order/channels', params)
}

// 获取运营渠道列表
export const getOrderDetails = (params) => {
    return postRequest('/videoclip/copyright/order/details', params)
}

// 获取申请记录详情页的数据
export const getFindDetailById = (params) =>{
    return postRequest('/videoclip/copyright/order/findDetailById', params)
}

// 自媒体管理我的能力查询
export const getAbilityFind = (params) =>{
    return postRequest('/wemedia/ability/find', params)
}

// 自媒体管理我的能力增加
export const getAbilityCreate = (params)=>{
    return postRequest('/wemedia/ability/create', params)
}

// 购物车确认发送申请接口
export const getOrderCreate = (params)=>{
    return postRequest('/videoclip/copyright/order/create', params)
}

// 我的能力更新接口
export const getAbilityUpdate = (params)=>{
    return postRequest('/wemedia/ability/update', params)
}

// 新加的判断是否是正确运营渠道的接口点击下一步时候
export const getAllValidateChannel = (params)=>{
    return postRequest('/videoclip/copyright/order/validateChannel',params)
}
// 数据托管增加接口
export const getYRInsertFront = (params) =>{
    return postFZRequest('/videoclip/wemedia/wemediaAccount/insertFront',params)
}


// WEBPACK FOOTER //
// ./src/api/shopcart.js